const MIC_ERRORS = {
  NotAllowedError: ['javascript.chat.mic_blocked', true],
  PermissionDeniedError: ['javascript.chat.mic_blocked', true],
  SecurityError: ['javascript.chat.mic_blocked', true],
  NotFoundError: ['javascript.chat.mic_no_device', false],
  DevicesNotFoundError: ['javascript.chat.mic_no_device', false],
  NotReadableError: ['javascript.chat.mic_in_use', false],
  TrackStartError: ['javascript.chat.mic_in_use', false],
  OverconstrainedError: ['javascript.chat.mic_device_unavailable', false],
  ConstraintNotSatisfiedError: ['javascript.chat.mic_device_unavailable', false]
};

export function classifyMicError(error) {
  const name = error && error.name ? error.name : 'UnknownError';
  const classification = MIC_ERRORS[name] || ['javascript.chat.mic_capture_failed', false];
  return { name, messageKey: classification[0], permissionDenied: classification[1] };
}

export async function acquireMicStream({ mediaDevices, deviceId }) {
  let audioInputCount = 0;
  try {
    const devices = await mediaDevices.enumerateDevices();
    audioInputCount = devices.filter(device => device.kind === 'audioinput').length;
  } catch (_) {
    // Device enumeration is diagnostic only and must not prevent capture.
  }

  const deviceSpecific = Boolean(deviceId && deviceId !== 'default');
  const constraints = deviceSpecific ? { audio: { deviceId: { exact: deviceId } } } : { audio: true };
  try {
    const stream = await mediaDevices.getUserMedia(constraints);
    return { stream, failure: null, stage: deviceSpecific ? 'device' : 'default', usedDefaultDevice: false, audioInputCount };
  } catch (error) {
    const failure = classifyMicError(error);
    if (!deviceSpecific || failure.permissionDenied) {
      return { stream: null, failure, stage: deviceSpecific ? 'device' : 'default', usedDefaultDevice: false, audioInputCount };
    }
  }

  try {
    const stream = await mediaDevices.getUserMedia({ audio: true });
    return { stream, failure: null, stage: 'default', usedDefaultDevice: true, audioInputCount };
  } catch (error) {
    return { stream: null, failure: classifyMicError(error), stage: 'default', usedDefaultDevice: true, audioInputCount };
  }
}
